<!--
 * @Author: your name
 * @Date: 2022-03-21 10:10:36
 * @LastEditTime: 2022-03-22 14:50:55
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /cmdc-web-v/Users/douyunfei/Documents/epec-mall/components/cart/pirce-sheet.vue
-->
<!-- 阶梯价 -->
<template>
  <div class="contents" :style="{ left: left, top: top }">
    <div class="price-content">
      <img
        src="~@/assets/img/purchase/icon-tangle@2x.png"
        alt=""
        :class="{ 'rotate-Img': top == '-38px' }"
      />
      <ul class="table-head">
        <li class="table-heade-tr">数量</li>
        <li class="table-heade-tr">价格</li>
      </ul>
      <ul class="table-content" v-for="(item, index) in priceTable" :key="item.priceId">
        <li class="table-heade-td" v-if="index == priceTable.length - 1">
          &ge;{{ item.startValue }}
        </li>
        <li class="table-heade-td" v-else>{{ item.startValue }}-{{ item.endValue }}</li>
        <li class="step-price">￥{{ item.price.toFixed(2) }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    priceTable: {
      type: Array,
      default() {
        return [];
      },
    },
    left: {
      type: String,
      default() {
        return '20px';
      },
    },
    top: {
      type: String,
      default() {
        return '34px';
      },
    },
  },
  data() {
    return {};
  },

  components: {},

  computed: {},

  created() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.contents {
  min-width: 520px;
  background: #fff;
  height: 80px;
  position: absolute;

  box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.209933);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
}
.price-content {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 32px;
    height: 16px;
    position: absolute;
    top: -20px;
    left: 22px;
  }
  .rotate-Img {
    transform: rotate(90deg);
    width: 32px;
    height: 16px;
    position: absolute;
    top: 28px;
    left: 496px;
  }
  .table-head {
    li {
      background: #f5f5f5;
      color: #333;
      font-size: 14px;
      width: 80px;
      height: 30px;
      text-align: center;
      line-height: 28px;
    }
    li {
      &:first-child {
        border: 1px solid #dcdcdc;
      }
      &:last-child {
        border-bottom: 1px solid #dcdcdc;
        border-left: 1px solid #dcdcdc;
        border-right: 1px solid #dcdcdc;
      }
    }
  }
  .table-content {
    li {
      min-width: 140px;
      height: 30px;
      text-align: center;
      line-height: 28px;
      color: #333;
      background: #fff;
    }
    li {
      &:first-child {
        border: 1px solid #dcdcdc;
      }
      &:last-child {
        border-bottom: 1px solid #dcdcdc;
        border-left: 1px solid #dcdcdc;
        border-right: 1px solid #dcdcdc;
        color: #f0250f;
      }
    }
  }
}
</style>
